// Cart recommendations: direct add (cart page + cart drawer)
(function(){
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.js-cart-rec-add');
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var vid = btn.dataset.variantId;
    if (!vid) return;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    var body = new URLSearchParams();
    body.append('id', vid);
    body.append('quantity', '1');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
      body: body.toString()
    }).then(function(r){
      if (!r.ok) throw new Error('add failed: ' + r.status);
      return r.json();
    }).then(function(){
      // On /cart page reload; on any other page (drawer context) refresh drawer + open it
      if (window.location.pathname === '/cart') {
        window.location.reload();
      } else {
        // Refresh the cart drawer content, then re-open it so user sees the new item
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        // Small delay to let refresh finish before reopening
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        }, 150);
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
      }
    }).catch(function(err){
      console.error('cart-rec add error', err);
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    });
  }, true);
})();
